import { EventsOfTask } from 'pages/Tasks/types'
import deleteWorkflowButton from 'redesign/components/templates/task-details-action-buttons/buttons/delete-workflow-button'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getCommentButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-comment-button'
import { getReminderButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-reminder-button'

export const getOfficePendingActionButtons = ({
  task,
  isOffice,
  sendEvent,
  refetch,
  setMessageDrawerProps,
  setDialogProps,
  handleButtonAction,
  canSendReminder,
  canSendComment,
  t,
}: ResolveActionButtonsProps) => [
  ...(canSendReminder ? [getReminderButton({ t, sendEvent, isOffice, task, refetch })] : []),
  ...(canSendComment
    ? [
        getCommentButton({
          t,
          sendEvent,
          refetch,
          setMessageDrawerProps,
          taskEvent: EventsOfTask.monthlySheetSendCommentToFrontline,
        }),
      ]
    : []),
  ...[deleteWorkflowButton({ t, sendEvent, refetch, setDialogProps, handleButtonAction, task })],
]
